import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

import { createRoute } from 'lib/util';

const NotificationHistoricActionsEdit = ({
  notificationHistoric,
  company,
  subcompany,
  t,
  handleClick = () => {},
}) => (
  <Form.Link
    className={'btn btn-outline-primary btn-sm mx-1'}
    to={createRoute(
      company.id,
      subcompany.id,
      `notifications_historic/${notificationHistoric.id}/edit`
    )}
  >
    {t('actions.edit')}
  </Form.Link>
);

export default translate()(NotificationHistoricActionsEdit);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/components/list/actions/NotificationsHistoricActionsEdit.js